import WeatherBox from './weather-box';
export default WeatherBox;
